/* Pattern for ad hoc query against relay store */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
  
  const abEnvironment = new AbEnvironment();
  const query = graphql`
  query UserFetchQuery($userName: String!) {
    allAccountFeatureTs(condition:{accountId:null}) {
      totalCount
      nodes {
        flagName
        flagValue
        flagValueTxt
      }
    },  
    userTByUserName(userName: $userName) {
      userId
      accountId
      userName
      userRole
      lastName
      firstName
      email
      phone
      address1
      address2
      city
      state
      country
      postalCode
      auth0Uid
      userConfirmDate
      termsAcceptDate
      accountLinkTsByUserId {
        totalCount
        nodes {
          accountLinkId
        }
      }
      accountTByAccountId {
        parentId
        accountStatus
        accountType
        accountNum
        accountName
        description
        contactLastName
        contactFirstName
        contactEmail
        contactPhone
        address1
        address2
        city
        state
        country
        postalCode
        accountConfirmDate
        achConfirmDate
        dwollaCid
        stripeCid
        hubspotId
        achActive
        leaddynoId
        leaddynoEmail
        customerStatus
        useBudgets
        personaStatus
        accountTsByParentId {
          totalCount
        }
        accountDelegatedAuthsTsByAccountId {
          totalCount
          nodes {
            appIntegrationId
            appName
            environment
          }
        }
        paymentSourceTsByAccountId {
          totalCount
          nodes {
            psStatus
            psType
          }
        }
        bindCardTsByProvisioningAccountId {
          totalCount
        }
        accountFeatureTsByAccountId {
          totalCount
          nodes {
            flagName
            flagValue
            flagValueTxt
          }
        }
        accountTByParentId {
          accountId
          accountName
          accountFeatureTsByAccountId {
            totalCount
            nodes {
              flagName
              flagValue
              flagValueTxt
            }
          }
        }
      }
    }
  }
  `;

  function fetch(userName) {
    const variables = {
      userName: userName
    }
    
    return fetchQuery(
      abEnvironment.getEnvironment(),
      query,
      variables
    );
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { fetch };

